import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-67063f66"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "FTLOrderPayment" }
const _hoisted_2 = { class: "FTLOrderPayment__container" }
const _hoisted_3 = { class: "container__block" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "block__title" }, "Данные об оплате", -1))
const _hoisted_5 = { class: "block__content" }
const _hoisted_6 = { class: "block__field" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "field__placeholder" }, "Компания", -1))
const _hoisted_8 = { class: "field__value" }
const _hoisted_9 = { class: "block__field" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "field__placeholder" }, "Способ оплаты за доставку", -1))
const _hoisted_11 = { class: "field__value" }
const _hoisted_12 = { class: "block__field" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "field__placeholder" }, "Объявленная стоимость", -1))
const _hoisted_14 = { class: "field__value" }
const _hoisted_15 = { class: "block__field" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "field__placeholder" }, "Кем будет производиться оплата", -1))
const _hoisted_17 = { class: "field__value" }
const _hoisted_18 = { class: "block__field" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "field__placeholder" }, "Предоплата", -1))
const _hoisted_20 = { class: "field__value" }
const _hoisted_21 = { class: "container__block" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "block__title" }, "Себестоимость", -1))
const _hoisted_23 = {
  key: 0,
  class: "mb-3"
}
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "font-semibold" }, "Доп. услуги", -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "font-semibold" }, "Перевозка", -1))
const _hoisted_26 = { class: "block__field mt-3" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "field__placeholder" }, "Общая себестоимость (включая доп. услуги)", -1))
const _hoisted_28 = { class: "field__value" }
const _hoisted_29 = { class: "container__block" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "block__title" }, "Выставление", -1))
const _hoisted_31 = {
  key: 0,
  class: "mb-3"
}
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "font-semibold" }, "Доп. услуги", -1))
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "font-semibold" }, "Перевозка", -1))
const _hoisted_34 = { class: "block__field mt-3" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "field__placeholder" }, "Общая сумма к оплате (включая доп. услуги)", -1))
const _hoisted_36 = { class: "field__value" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ftl_additional_service_table = _resolveComponent("ftl-additional-service-table")!
  const _component_ftl_cost_table = _resolveComponent("ftl-cost-table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.companyName || '-'), 1)
          ]),
          _createElementVNode("div", _hoisted_9, [
            _hoisted_10,
            _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.paymentMethod || '-'), 1)
          ]),
          _createElementVNode("div", _hoisted_12, [
            _hoisted_13,
            _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.formatAmount(_ctx.declaredPrice)), 1)
          ]),
          _createElementVNode("div", _hoisted_15, [
            _hoisted_16,
            _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.paymentType || '-'), 1)
          ]),
          _createElementVNode("div", _hoisted_18, [
            _hoisted_19,
            _createElementVNode("div", _hoisted_20, [
              (_ctx.isPrepayment)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createTextVNode(" Да ")
                  ], 64))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createTextVNode(" Нет ")
                  ], 64))
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_21, [
        _hoisted_22,
        (_ctx.additionalService.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
              _hoisted_24,
              _createVNode(_component_ftl_additional_service_table, {
                city: _ctx.senderCity,
                "additional-service": _ctx.additionalService
              }, null, 8, ["city", "additional-service"])
            ]))
          : _createCommentVNode("", true),
        _hoisted_25,
        _createVNode(_component_ftl_cost_table, {
          "ftl-order": _ctx.ftlOrder,
          "is-first": "",
          class: "mt-3"
        }, null, 8, ["ftl-order"]),
        _createElementVNode("div", _hoisted_26, [
          _hoisted_27,
          _createElementVNode("div", _hoisted_28, _toDisplayString(_ctx.formatAmount(_ctx.costTotal)), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_29, [
        _hoisted_30,
        (_ctx.additionalService.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
              _hoisted_32,
              _createVNode(_component_ftl_additional_service_table, {
                city: _ctx.senderCity,
                "additional-service": _ctx.additionalService,
                "is-paid-price": ""
              }, null, 8, ["city", "additional-service"])
            ]))
          : _createCommentVNode("", true),
        _hoisted_33,
        _createVNode(_component_ftl_cost_table, {
          "ftl-order": _ctx.ftlOrder,
          "is-second": "",
          class: "mt-3"
        }, null, 8, ["ftl-order"]),
        _createElementVNode("div", _hoisted_34, [
          _hoisted_35,
          _createElementVNode("div", _hoisted_36, _toDisplayString(_ctx.formatAmount(_ctx.paidPriceTotal)), 1)
        ])
      ])
    ])
  ]))
}